import { render } from "./FullscreenLoader.vue?vue&type=template&id=4b07da65"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js"

import "./FullscreenLoader.vue?vue&type=style&index=0&id=4b07da65&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__